import { jsx as _jsx } from "react/jsx-runtime";
import { At, Calendar, Camera, Copyright, Fields, FolderOpen, Import, Key, Location, LocationsIcon, Palette, People, Plus, Tag, User, Video } from "@air/next-icons";
export const AllDateFilters = [
    "dateCreated",
    "dateUploaded",
    "dateModified",
    "dateTaken"
];
export const AllAudioVisualFilters = [
    "videoFrameRate",
    "videoAspectRatio",
    "audioCoding",
    "audioSampleRate"
];
export const AllLocationFilters = [
    "country",
    "city",
    "state"
];
const filtersInOrder = [
    "locations",
    "type",
    "uploader",
    "color",
    "camera",
    "creator",
    "copyright",
    "importedKeywords",
    "people",
    "extension",
    "location",
    "city",
    "state",
    "country",
    "source",
    "customField",
    "tags",
    "audioVisual",
    "audioCoding",
    "audioSampleRate",
    "videoAspectRatio",
    "videoFrameRate",
    "date",
    "dateCreated",
    "dateModified",
    "dateTaken",
    "dateUploaded",
    "other"
];
export const filtersOrder = filtersInOrder.reduce((acc, filter, index)=>{
    acc[filter] = index;
    return acc;
}, {});
export const sortFiltersByOrder = (filterA, filterB)=>{
    var _filtersOrder_filterA, _filtersOrder_filterB;
    return ((_filtersOrder_filterA = filtersOrder[filterA]) !== null && _filtersOrder_filterA !== void 0 ? _filtersOrder_filterA : 0) - ((_filtersOrder_filterB = filtersOrder[filterB]) !== null && _filtersOrder_filterB !== void 0 ? _filtersOrder_filterB : 0);
};
export const baseFiltersOptions = {
    audioCoding: {
        id: "audioCoding",
        label: "Audio Coding",
        icon: Video
    },
    audioSampleRate: {
        id: "audioSampleRate",
        label: "Audio Sample Rate",
        icon: Video
    },
    audioVisual: {
        id: "audioVisual",
        label: "Audio/Visual",
        icon: Video
    },
    camera: {
        id: "camera",
        label: "Camera",
        icon: Camera
    },
    city: {
        id: "city",
        label: "City",
        icon: Location
    },
    color: {
        id: "color",
        label: "Color",
        icon: Palette
    },
    copyright: {
        id: "copyright",
        label: "Copyright",
        icon: Copyright
    },
    country: {
        id: "country",
        label: "Country",
        icon: Location
    },
    creator: {
        id: "creator",
        label: "Creator",
        icon: User
    },
    customField: {
        id: "customField",
        label: "Custom field",
        icon: Fields
    },
    date: {
        id: "date",
        label: "Date",
        icon: Calendar
    },
    dateCreated: {
        id: "dateCreated",
        label: "Date created",
        icon: Calendar
    },
    dateModified: {
        id: "dateModified",
        label: "Date modified",
        icon: Calendar
    },
    dateTaken: {
        id: "dateTaken",
        label: "Date taken",
        icon: Calendar
    },
    dateUploaded: {
        id: "dateUploaded",
        label: "Date uploaded",
        icon: Calendar
    },
    extension: {
        id: "extension",
        label: "Extension",
        icon: At
    },
    importedKeywords: {
        id: "importedKeywords",
        label: "Imported keywords",
        icon: Key
    },
    location: {
        id: "location",
        label: "Location",
        icon: Location
    },
    other: {
        id: "other",
        label: "More filters",
        icon: Plus
    },
    people: {
        id: "people",
        label: /*#__PURE__*/ _jsx("div", {
            className: "flex items-center gap-2",
            children: "People"
        }),
        icon: People
    },
    smartTags: {
        id: "smartTags",
        label: "Smart tags",
        icon: Tag
    },
    source: {
        id: "source",
        label: "Source",
        icon: Import
    },
    state: {
        id: "state",
        label: "State/Province",
        icon: Location
    },
    tags: {
        id: "tags",
        label: "Tags",
        icon: Tag
    },
    type: {
        id: "type",
        label: "Type",
        icon: FolderOpen
    },
    uploader: {
        id: "uploader",
        label: "Uploader",
        icon: User
    },
    videoAspectRatio: {
        id: "videoAspectRatio",
        label: "Signal Aspect Ratio",
        icon: Video
    },
    videoFrameRate: {
        id: "videoFrameRate",
        label: "Video Frame Rate",
        icon: Video
    },
    locations: {
        id: "locations",
        label: "Locations",
        icon: LocationsIcon
    }
};
